import React from 'react';

function Skills() {
  return (
    <div className="skills-card">
      <div className="skills-page-container">
        <h1>Skills</h1>
        <div className="skills-grid">
          <div className="skills-category">
            <h2>Game Programming & Engines</h2>
            <div className="skills-badges">
              <span className="skill-badge">Unity (C#)</span>
              <span className="skill-badge">Unreal Engine</span>
              <span className="skill-badge">Godot</span>
              <span className="skill-badge">GDScript (Godot)</span>
              <span className="skill-badge">LibGDX</span>
              <span className="skill-badge">DirectX 11</span>
              <span className="skill-badge">DirectX 12</span>
              <span className="skill-badge">OpenGL</span>
              <span className="skill-badge">Game Engine Development</span>
              <span className="skill-badge">Physics Simulation</span>
              <span className="skill-badge">Real-time Graphics</span>
              <span className="skill-badge">Multiplayer Systems</span>
              <span className="skill-badge">Backend Systems</span>
              <span className="skill-badge">REST APIs</span>
            </div>
          </div>
          <div className="skills-category">
            <h2>Game Programming & Engineering Soft Skills</h2>
            <div className="skills-badges">
              <span className="skill-badge">Game Design</span>
              <span className="skill-badge">Game Mechanics</span>
              <span className="skill-badge">Level Design</span>
              <span className="skill-badge">Game Physics</span>
              <span className="skill-badge">Problem Solving</span>
              <span className="skill-badge">Collaboration</span>
              <span className="skill-badge">Communication</span>
              <span className="skill-badge">Team Leadership</span>
              <span className="skill-badge">Project Management</span>
            </div>
          </div>
          <div className="skills-category">
            <h2>Programming Languages</h2>
            <div className="skills-badges">
              <span className="skill-badge">C#</span>
              <span className="skill-badge">C++</span>
              <span className="skill-badge">Python</span>
              <span className="skill-badge">JavaScript</span>
              <span className="skill-badge">Java</span>
              <span className="skill-badge">Dart</span>
              <span className="skill-badge">C</span>
              <span className="skill-badge">SQL (MySQL, SQL Server, Oracle)</span>
              <span className="skill-badge">Visual Basic</span>
            </div>
          </div>
          <div className="skills-category">
            <h2>Graphics, Shaders & Art</h2>
            <div className="skills-badges">
              <span className="skill-badge">Pixel Art</span>
              <span className="skill-badge">Blender</span>
              <span className="skill-badge">Shaders (HLSL, GLSL)</span>
            </div>
          </div>
          <div className="skills-category">
            <h2>Frameworks & Libraries</h2>
            <div className="skills-badges">
              <span className="skill-badge">React</span>
              <span className="skill-badge">React Native</span>
              <span className="skill-badge">Flutter</span>
              <span className="skill-badge">Node.js</span>
              <span className="skill-badge">ASP.NET</span>
              <span className="skill-badge">Windows Forms (.NET)</span>
              <span className="skill-badge">SQLite</span>
            </div>
          </div>
          <div className="skills-category">
            <h2>AI, Computer Vision & Automation</h2>
            <div className="skills-badges">
              <span className="skill-badge">AI (Python)</span>
              <span className="skill-badge">OpenCV</span>
              <span className="skill-badge">Computer Vision (OpenCV, Aruco Markers)</span>
              <span className="skill-badge">Automation</span>
            </div>
          </div>
          <div className="skills-category">
            <h2>Tools & Version Control</h2>
            <div className="skills-badges">
              <span className="skill-badge">Git</span>
              <span className="skill-badge">Bitbucket</span>
              <span className="skill-badge">SVN</span>
              <span className="skill-badge">Jira</span>
              <span className="skill-badge">Agile</span>
              <span className="skill-badge">Scrum</span>
              <span className="skill-badge">Visual Studio</span>
              <span className="skill-badge">Rider</span>
              <span className="skill-badge">Android Studio</span>
            </div>
          </div>
          <div className="skills-category">
            <h2>Other</h2>
            <div className="skills-badges">
              <span className="skill-badge">Software Development</span>
              <span className="skill-badge">Cross-Platform Development</span>
              <span className="skill-badge">UI/UX Design</span>
              <span className="skill-badge">Teaching & Mentoring</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills; 